export { DynamicPackagesConfigurationWizardConnected as DynamicPackagesConfigurationWizard } from './container';
